import HexController from 'controllers/hex_controller'

export default class UpdateAuthenticityTokenController extends HexController {
  connect() {
    this.element.onsubmit = () => {
      this.element.querySelector('input[name="authenticity_token"]').value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    }
  }
}
